export type CalendarPublication = Readonly<{
    id: number;
    title: string;
    content: string;
    media: string;
    extension: string;
    publicationDate: string;
    social?: string[] | string;
    link?: string;
    isGlobal?: boolean;
}>;

export enum CalendarGranularity {
    Month = 'month',
    Week = 'week',
    Day = 'day',
}

export type CalendarCellRectSnapshot = Readonly<{
    left: number;
    top: number;
    width: number;
    height: number;
}>;

export type CalendarPublicationHoverAnchor = Readonly<{
    clientX: number;
    clientY: number;
    cellRect?: CalendarCellRectSnapshot;
    keepDayListOpen?: boolean;
}>;

export type PopoverPosition = Readonly<{ top: number; left: number }>;
